var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagebox"},[_vm._m(0),_c('div',{staticClass:"succcesstxt"},[_vm._v("提交成功")]),_c('div',{staticClass:"btn",on:{"click":_vm.detail}},[_vm._v("查看退货详情")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"successimg"},[_c('img',{attrs:{"src":require("../../../../assets/refund/icon_successful@2x.png"),"alt":""}})])
}]

export { render, staticRenderFns }